
import { useState, useRef, useEffect } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

//Components
import CheckCircle from '@mui/icons-material/CheckCircle';
import Cancel from '@mui/icons-material/Cancel';
import {
    Modal,
    ModalBody,
    ModalFooter,
    Button,
    Input,
    Form,
    Checkbox,
} from "@gpstrackit/react-controls";
import CustomCard from 'Components/Card';
import CoverageDetailInfo from 'Modules/devices/.components/coverageDetailInfo'

//Notification
import { NotificationManager } from "Components/Notifications";
import { getDateFormatted, copyToClipboard } from 'Core/data/Helpers';

//Permission
import { HasPermission } from "Core/security"

//Actions
import {
    createDiagnosticDeviceRequest,
    coverageDetailInfoOpenModal,
    clearRedux,
} from 'Redux/actions';

const CoverageDetails = (props) => {
    const formRef = useRef(null);
    const formTwoRef = useRef(null);
    const { messages } = useIntl();
    const { tableRef, single, getDevice } = props;
    const dispatch = useDispatch();
    const navigate = useNavigate();

    //Redux States
    const { device, loading, openModal, id, devices, selectedDevices } = useSelector(state => state.coverageDetailsRedux)
    const user = useSelector(state => state.securityRedux.user);
    const coverageResult = useSelector(state => state.createDiagnosticDeviceRedux.result);
    const coverageLoading = useSelector(state => state.createDiagnosticDeviceRedux.loading);
    const openModalCoverageDetailInfo = useSelector(state => state.coverageDetailInfoRedux.openModal);

    //Local States
    const [coverageScore, setCoverageScore] = useState(null);
    const [coverageUpdatedOn, setCoverageUpdatedon] = useState(null);
    const [coverageDetail, setCoverageDetail] = useState([]);

    const createDiviceDiagnostic = () => {
        let payload = {
            unitIds: [id]
        }
        dispatch(createDiagnosticDeviceRequest(payload));

    }

    const closeModal = () => {
        setCoverageDetail([])
        dispatch(clearRedux("COVERAGE_DETAILS"));
    }

    useEffect(() => {
        if (device) {
            let detail = JSON.parse(JSON.parse(device.unitConfig.coverageDetail))
            setCoverageDetail(detail)
            setCoverageScore(device.unitConfig.coverageScore)
            setCoverageUpdatedon(device.unitConfig.coverageUpdatedOn)
        }
    }, [device])

    useEffect(() => {
        if (coverageResult) {
            dispatch(clearRedux("CREATE_DIAGNOSTIC_DEVICE", { result: null }));
            if (!coverageResult?.error) {
                let transactionId = coverageResult.DiagnosticResult.transactionId;
                let message = messages["create_diagnostic_device_transaction_request_message"]
                NotificationManager.success(message, messages['create_diagnostic_device_title'], 10000, () => {
                    copyToClipboard(transactionId, messages['common_copied']);
                    navigate(`/app/transactions/list/${transactionId}`);

                }, null, '', null);

            } else {
                let error = true;
                let message = messages["devices_import_save_error"]
                if (coverageResult?.error?.error) {
                    if (messages[coverageResult.error.error])
                        message = messages[coverageResult.data.error.error]
                    else
                        message = coverageResult.error.error.replace("Bad request ->", "").replace("GraphQL error: ", "")
                }
            }
        }
    }, [coverageResult]);

    useEffect(() => {
        return () => {
            closeModal()
        }
    },[])

    return (
        <Modal
            open={openModal}
            title={`${messages['coverage_details_title']}${device ? ` - ${device.label}` : ""}`}
            position="right"
            size="small"
            handleClose={closeModal}
            loading={loading || coverageLoading}
        >
            <ModalBody>
                {
                    coverageScore != null &&
                    <div style={{ padding: '0 10px' }}>
                        <label style={{ marginTop: 5, display: "flex" }}>
                            <p style={{ fontWeight: "bold", marginRight: 5 }}>{messages['coverage_details_score']}:</p> {`${coverageScore != null ? `${coverageScore.toFixed(2)}%` : ""}`}
                        </label>
                    </div>
                }
                {
                    coverageUpdatedOn != null &&
                    <div style={{ padding: '0 10px' }}>
                        <label style={{ marginTop: 5, display: "flex" }}>
                            <p style={{ fontWeight: "bold", marginRight: 5 }}>{messages['coverage_details_updated_on']}:</p> {getDateFormatted(coverageUpdatedOn, "date", "datetime", null)}
                        </label>
                    </div>
                }
                <div style={{ padding: '0 10px' }}>
                    <Button
                        disabled={loading || coverageLoading || !HasPermission(user, "dvdiag", "c")}
                        className="btn-dark-blue"
                        onClick={() => {
                            createDiviceDiagnostic();
                        }}
                    >
                        {messages['coverage_details_update_diagnostic']}
                    </Button>
                </div>
                <div style={{ padding: '0 10px' }}>
                    {coverageDetail?.length > 0 ? coverageDetail.map((item, index) => {
                        return (
                            <CustomCard
                                key={index}
                                onClick={() => {
                                    if (!item.pass) {
                                        dispatch(coverageDetailInfoOpenModal(JSON.stringify(item.details, undefined, 2)));
                                    }
                                }}
                                customMessage={item.pass ? messages["coverage_details_pass"] : messages["coverage_details_fail"]}
                                customIcon={item.pass ? () => {
                                    return (
                                        <CheckCircle style={{ color: 'green' }} />
                                    )
                                } : () => {
                                    return (
                                        <Cancel style={{ color: 'red' }} />
                                    )
                                }
                                }
                            >
                                <div style={{ display: 'grid' }}>
                                    <div>
                                        <label style={{ fontWeight: 700, marginRight: 5 }}>{messages[`coverage_details_${item.name}`]}</label>
                                    </div>
                                </div>
                            </CustomCard>
                        )
                    }) : <div style={{ display: 'flex', justifyContent: 'center', marginTop: 25 }} ><span style={{ opacity: 0.6 }} >{messages['coverage_details_no_details']}</span></div>}
                </div>
                {openModalCoverageDetailInfo && <CoverageDetailInfo />}
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn btn-dark-blue"
                    onClick={() => closeModal()}
                >
                    {messages['common_cancel']}
                </Button>
            </ModalFooter>
        </Modal >
    )
}

export default CoverageDetails;